/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Carousel } from 'react-responsive-carousel';
import './style.css';
import Img from "gatsby-image";
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'
import * as actions from '../../actions/modal'
import * as actPortfolio from '../../actions/portfolio';
import windowSize from 'react-window-size';

//let _w = [6, 6, 4, 4, 4, 6, 6, 4, 4, 4, 4, 6, 6, 4, 4, 4,6, 6, 4, 4, 4,6, 6, 4, 4, 4];//set in props
//let _w = [4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3]

const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    desktop:1200,
    large:1400
};


class GridPortfolio extends Component {
  constructor (props) {
    super(props);
    this.state = {
      screenWidth: '',
      screenHeight: ''
    };
    this._openWithId =   this._openWithId.bind(this);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
  };

  _openWithId(id,index) {
    //remove scroll of the body, to prevent scrolling - this is a bug of the Modal component.
    document.documentElement.style.overflowY = 'hidden';

    //send to the store, the portfolio id value
    if(this.props.gallery){
      // Gallery when the thumbs feature the same project, we open a a certain position.
      this.props.openWithId(id, index);
    }else{
      // if the thumbs are for different project we open at first position
      this.props.openWithId(id, 0);
    }

  }

  RowOdd(index, size, title, subheadline, slug, external, text){
    var _w = this.props.raster;
    var _b = this.props.infoBox;
    var _c = this.props.bottomSpace;
    var _d = this.props.infoPos;


    return (
        <Col key={"x-"+index} className={"even cnt-reg-img size_" + _w[index] + " info_" + _b[index] + " space_" + _c[index] + " pos_" + _d[index]} xs={12} sm={_w[index]} md={_w[index]} lg={_w[index]}>

        {slug !== '' ?

        <a className="cnt-item" href={ external !== 1 ? "#/" + slug : slug } onClick={ external !== 1 ? () => this._openWithId(slug,index) : function(){return false;}}><Img sizes={size}/>

        <div className="info is-hidden-mobile"><h4>{title}<hr/><span className="sub">{subheadline}</span></h4></div>
        {index == this.props.morePos ? <div className="gPlus has-text-centered"><span>{this.props.moreTxt}</span></div> : ''}
        </a> :
        <div className="cnt-item"><Img sizes={size}/>
        <div className="info is-hidden-mobile"><h4>{title}<hr/><span className="sub">{subheadline}</span></h4></div>
        </div>
      }
        </Col>
          );

  }

  RowEven(index, size, title, subheadline, slug,external, text){
    var _w = this.props.raster;
    var _b = this.props.infoBox;
    var _c = this.props.bottomSpace;
    var _d = this.props.infoPos;
    return (
      <Col key={"x-"+index} className={"even cnt-reg-img size_" + _w[index] + " info_" + _b[index] + " space_" + _c[index] + " pos_" + _d[index]} xs={12} sm={_w[index]} md={_w[index]} lg={_w[index]}>
      {slug !== '' ?

      <a className="cnt-item" href={ external !== 1 ? "#/" + slug : slug } onClick={ external !== 1 ? () => this._openWithId(slug,index) : function(){return false;} }><Img sizes={size}/>

      <div className="info is-hidden-mobile"><h4>{title}<hr/><span className="sub">{subheadline}</span></h4></div>
      {index == this.props.morePos ? <div className="gPlus has-text-centered"><span>{this.props.moreTxt}</span></div> : ''}
      </a>
      :
      <div className="cnt-item"><Img sizes={size}/>
      <div className="info is-hidden-mobile"><h4>{title}<hr/><span className="sub">{subheadline}</span></h4></div>
      </div>
    }
      </Col>
          );
  }

  getImgData(index, size, title, subheadline, slug){

    return (
      <div key={"-" + index}>
      <Img style={{'display': 'block'}} alt={title} title={title} sizes={size}/>

          <div className="legend has-text-centered has-text-weight-light">
          {title} <br/>
          {subheadline}
          </div>

      </div>
    );
  }

  componentWillMount(){
    //this.setState({screenWidth: window.innerWidth });
    //console.log('this.props.screenWidth' + this.props.windowWidth);
  }

  componentDidMount() {
  window.addEventListener('resize', this.handleWindowSizeChange);
  this.handleWindowSizeChange();
}

// make sure to remove the listener
// when the component is not mounted anymore
componentWillUnmount() {
  window.removeEventListener('resize', this.handleWindowSizeChange);
}

handleWindowSizeChange = () => {
  this.setState({ screenWidth: window.innerWidth, screenHeight:window.innerHeight });
  //console.log(window.innerWidth + '  ' +  window.innerHeight)
};


    render() {
      var data = this.props.data;
      var dataMobile = this.props.dataMobile;
      const ar1 = data.edges;
      const arMobile = dataMobile.edges;
      const ar2 = this.props.dataInfo.sort();

      //console.log(ar2)


      var screenWidth =  this.state.screenWidth ; //this.props.screenWidth;
      //console.log(screenWidth);

      if(this.state.screenWidth < breakpoint.mobile && this.props.mobileCarousel) {
        // smaller than breakpoint mobile
        return (
          <Carousel
          showIndicators={false}
          className="topSlider"
          showThumbs={false}
          showArrows={true}
          /*centerMode={true}
          centerSlidePercentage={100}*/
          emulateTouch={true}
          showStatus={false}
          autoPlay={false}
          stopOnHover={true}
          infiniteLoop={true}
          useKeyboardArrows={true}
          interval={3000}
          transitionTime={500}
          onClickItem={(i) => ar2[i].image[0].slug != '' && ar2[i].image[0].external !== 1 ? this._openWithId( ar2[i].image[0].slug) : function(){return false;} }
          >
            {ar2.map(({image}, index) => (

              index < this.props.mobilePictCount ?

              this.getImgData(
                index,
                //we use this src when pulled from frontmatter without using imagesharp (just a string)
                //image[0].src,
                arMobile[index].node.sizes, //from imagesharp
                image[0].title,
                image[0].sub_headline,
                image[0].slug,
                image[0].external
              )
              :
              ''

          )  )}
          </Carousel>
        );
      }else{

        // greater than breakpoint mobile
        return (
          <div>
              <Grid fluid>
              <Row className="cnt no-padding">

              {ar2.map(({image}, index) => (

                index < (this.state.screenWidth < breakpoint.mobile ? this.props.mobilePictCount : this.props.pictCount) ?

                index % 2  ?
                this.RowEven(
                  index,
                  //we use this src when pulled from frontmatter without using imagesharp (just a string)
                  //image[0].src,

                  this.state.screenWidth < breakpoint.mobile  ? arMobile[index].node.sizes : ar1[index].node.sizes, //from iamagesharp
                  image[0].title,
                  image[0].sub_headline,
                  image[0].slug,
                  image[0].external,
                  image[0].text
                )
                :
              this.RowOdd(
                index,
                //image[0].src, //idem
                this.state.screenWidth < breakpoint.mobile  ? arMobile[index].node.sizes : ar1[index].node.sizes,
                image[0].title,
                image[0].sub_headline,
                image[0].slug,
                image[0].external,
                image[0].text
              )
              : ''
            )  )}
            </Row>
            <Row className="is-hidden-tablet">
            <div className="info-mobile"><h4 className="has-text-centered">{ar2[0].image[0].title}<hr/><span className="sub has-text-centered">{ar2[0].image[0].sub_headline}</span></h4></div>
            </Row>
              </Grid>
          </div>
        );

      }




    }
  }
  GridPortfolio.propTypes = {
      data: PropTypes.object.isRequired,
      dataInfo: PropTypes.array.isRequired,
      modalVisible: PropTypes.bool.isRequired,
      openWithId: PropTypes.func.isRequired,
      close: PropTypes.func.isRequired,
      pf_id: PropTypes.string.isRequired,
      screenWidth: PropTypes.number.isRequired,
      screenHeight: PropTypes.number.isRequired,
      raster: PropTypes.array.isRequired
  };



  const mapStateToProps = ({ modalVisible, openWithId, close, lang, screenWidth, screenHeight }) => {
    return { modalVisible, openWithId, close, lang, screenWidth, screenHeight }
  }

  const mapDispatchToProps = dispatch => {
    return {
      openWithId: (v,i) => dispatch(actions.open_with_id(v,i)),
      close: () => dispatch(actions.close()),
     }
  }

  const ConnectedGridPortfolio = connect(mapStateToProps, mapDispatchToProps)(GridPortfolio)

  export default ConnectedGridPortfolio



// WEBPACK FOOTER //
// ./src/components/ConnectedGridPortfolio/index.js